/* eslint-disable */
import pkg from './package.json'
import common from './common'
// export const CTTQMonitor = common
// export const version = pkg.version
export default {
  version: pkg.version,
  CTTQMonitor: common
}